import { ComponentProps } from "react";
import { Link, LinkProps } from "remix";

const buttonBase = "inline-flex font-semibold rounded-md items-center";
const buttonVariants = {
  primary: `${buttonBase} bg-primary-600 hover:bg-primary-500 text-white`,
  secondary: `${buttonBase} bg-primary-50 hover:bg-primary-100 text-primary-700`,
  ghost: `${buttonBase} bg-transparent hover:bg-primary-100 text-primary-700`,
  destroy: `${buttonBase} bg-red-50 hover:bg-red-100 text-red-700 disabled:bg-gray-50 disabled:text-gray-700 disabled:pointer-none`,
};
const buttonSizes = {
  md: "text-lg px-6 py-3",
  sm: "text-base px-2 py-1",
  xs: "text-sm px-1 py-1",
};

type ButtonVariant = keyof typeof buttonVariants;
type ButtonSize = keyof typeof buttonSizes;

export interface ButtonOwnProps {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

export function ButtonLink({
  className,
  variant = "primary",
  size = "md",
  ...props
}: ButtonOwnProps & LinkProps) {
  return (
    <Link
      className={`${buttonVariants[variant]} ${buttonSizes[size]} no-underline ${className}`}
      {...props}
    />
  );
}

export function ButtonHyperLink({
  className,
  variant = "primary",
  size = "md",
  ...props
}: ButtonOwnProps & ComponentProps<"a">) {
  return (
    <a
      className={`${buttonVariants[variant]} ${buttonSizes[size]} no-underline ${className}`}
      {...props}
    />
  );
}

export function Button({
  className,
  variant = "primary",
  size = "md",
  ...props
}: ButtonOwnProps & ComponentProps<"button">) {
  return (
    <button
      className={`${buttonVariants[variant]} ${buttonSizes[size]} ${className}`}
      {...props}
    />
  );
}

const editButtonStyles = `${buttonBase} ${buttonSizes.sm} bg-gray-500 hover:bg-gray-600 text-white`;
export function EditButton({ className, ...props }: ComponentProps<"button">) {
  return <button className={`${editButtonStyles} ${className}`} {...props} />;
}
export function EditButtonLink({ className, ...props }: LinkProps) {
  return <Link className={`${editButtonStyles} ${className}`} {...props} />;
}
